<template>
  <div id="main">
    <loader v-if="isLoading" />
    <alert-container :messages="msgs" />
    <div class="listing-header mb-3">
      <div class="title-breadcrumb">
        <h1 class="title">
          {{ $t("vincular-prazo-pagamento") }}
        </h1>
      </div>
      <div class="header-buttons">
        <button class="delete-btn" type="button" @click="fecharModal()">
          {{ $t("cancelar") }}
        </button>
        <button
          class="save-btn"
          type="button"
          @click="save"
          :disabled="prazoPagamentoSelecionados.length === 0"
        >
          {{ $t("salvar") }}
        </button>
      </div>
    </div>
    <br />
    <div class="search-and-filter">
      <div class="search-bar">
        <search-bar :onSearch="debouncedOnSearch" />
      </div>
    </div>
    <div class="registry-wrapper">
      <empty-table-message v-if="isEmpty" />
      <b-table
        v-else
        :data="prazoPagto"
        class="data-table"
        @sort="sortTable"
        backend-sorting
        checkable
        :checked-rows.sync="prazoPagamentoSelecionados"
        :custom-is-checked="isPrazoChecked"
        row-key="idPrazoPagto"
      >
        <b-table-column
          v-for="(f, i) in fields"
          :key="i"
          :field="f.key"
          :label="$t(f.key)"
          :width="f.width"
          :sortable="f.sortable"
          v-slot="props"
        >
          <span>{{ props.row[f.key] }}</span>
        </b-table-column>
      </b-table>
      <PaginationViewer
        class="mb-0"
        :resetPagination="pagination.resetPagination"
        :totalItems="pagination.totalRows"
        :perPageOptions="pagination.perPageOptions"
        :optionStarted="pagination.optionStarted"
        @change="updatePagination"
      />
    </div>
  </div>
</template>

<script>
import AssPrazoPagamentoB2BEmpresaService from "@/services/b2b/AssPrazoPagamentoB2BEmpresaService";
import AssPrazoPagamentoEmpresaService from "@/services/vendas/empresa/abas/AssPrazoPagamentoEmpresaService";
import Message from '@/models/Message.js';

/* @70957 */
export default {
  props: {
    idEmpresa: 0,
  },
  data() {
    return {
      service: new AssPrazoPagamentoB2BEmpresaService(this.$http, this.$router),
      prazoPagtoService: new AssPrazoPagamentoEmpresaService(
        this.$http,
        this.$router
      ),
      prazoPagto: [],
      isLoading: false,
      isEmpty: false,
      fields: [{ key: "descricao", width: null, sortable: true }],
      prazoPagamentoSelecionados: [],
      idprazopagto: 0,
      debouncedOnSearch: null,
      queryFilter: "",
      pagination: {
        resetPagination: false,
        perPageOptions: [10, 25, 50, 100],
        optionStarted: 0,
        perPage: null,
        totalRows: 0,
        currentPage: 1,
      },
      column: "descricao",
      order: "asc",
      msgs: [],
    };
  },
  created() {
    this.pagination.perPage =
      this.pagination.perPageOptions[this.pagination.optionStarted];
    this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    this.carregarDados();
  },
  methods: {
    isPrazoChecked(selectedRow, row) {
      return selectedRow.idPrazoPagto === row.idPrazoPagto;
    },
    carregarDados(currentPage = 1) {
      if (currentPage == 1 && this.pagination.currentPage != 1) {
        this.pagination.resetPagination = true;
      }
      this.isLoading = true;
      this.prazoPagtoService
        .findAllNaoAssociados(
          this.column,
          this.order,
          currentPage - 1,
          this.pagination.perPage,
          this.idEmpresa,
          this.queryFilter
        )
        .then(this.mapItems)
        .then((value) => {
          this.prazoPagto = value;

          this.isEmpty = this.prazoPagto.length === 0;
        })
        .catch((e) => {
          this.isEmpty = true;
          this.$root.showMessage("error", "msg-erro-load");
          console.error("Erro ao carregar os dados.");
        })
        .finally((_) => {
          this.isLoading = false;
          this.pagination.resetPagination = false;
        });
    },
    mapItems(body) {
      this.pagination.totalRows = body.totalElements;

      return body.content.map((m) => {
        return {
          idEmpresa: Number(this.idEmpresa),
          idPrazoPagto: m.idprazopagto,
          descricao: m.descricao,
        };
      });
    },
    sortTable(field, order) {
      this.column = field;
      this.order = order;
      this.carregarDados(this.pagination.currentPage);
    },
    onSearch(value) {
      this.queryFilter = this.removeAcentos(value);
      this.pagination.currentPage = 1;
      this.carregarDados();
    },
    updatePagination(value) {
      this.pagination.resetPagination = false;
      this.pagination.perPage = value.perPage;
      this.pagination.currentPage = value.currentPage;
      this.carregarDados(value.currentPage);
    },
    save() {
      if (this.prazoPagamentoSelecionados.length > 0) {
        this.isLoading = true;

        this.service
          .insertBulk(this.prazoPagamentoSelecionados)
          .then((value) => {
            if (value.content === null) {
              this.msgs.push(new Message("error", `${value.message}`, true));
            } else {
              this.$emit("fecharModal", true);
              this.$root.showMessage(
                "success",
                "msg-sucesso-ao-adicionar-associacao"
              );
            }
          })
          .catch(() => {
            this.msgs.push(new Message("alert", "msg-erro-vincular-prazo-pagto", true));
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.msgs.push(
          new Message("error", "msg-selecione-prazo-pagamento", true)
        );
        this.isLoading = false;
      }
    },
    fecharModal() {
      this.$emit("fecharModal", true);
    },
  },
};
</script>
<style lang="scss" scoped>
#main {
  padding: 20px 20px;
  .search-and-filter {
    .search-bar {
      width: 100%;
    }
    @media (max-width: 760px) {
      .search-bar {
        padding-right: 0;
      }
    }
  }
}
</style>
